<template>
  <div v-if="type !== 'hidden'" :class="{
    'input--invalid': shouldShowValidationError(),
    'input--required': isRequired(),
    'input--half-width': halfWidth,
    'input--disabled': disabled
  }">

    <input-label-full-width
      :label="label"
      :required="required">
    </input-label-full-width>

    <template v-if="type === 'text'">
      <input type="text" v-on:blur="blur" v-on:input="input" v-model="pendingValue" :disabled="disabled" v-on:keydown.enter="enter"/>
    </template>

    <template v-if="type === 'email'">
      <input type="email" v-on:blur="blur" v-on:input="input" v-model="pendingValue" :disabled="disabled" v-on:keydown.enter="enter"/>
    </template>

    <template v-if="type === 'tel'">
      <input type="tel" v-on:blur="blur" v-on:input="input" v-model="pendingValue" :disabled="disabled" v-on:keydown.enter="enter"/>
    </template>

    <template v-if="type === 'password'">
       <input type="password" v-on:blur="blur" v-on:input="input" v-model="pendingValue" :disabled="disabled" v-on:keydown.enter="enter"/> 
    </template>

    <template v-if="type === 'textarea'">
      <textarea v-model="pendingValue" v-on:blur="blur" v-on:input="input" :disabled="disabled"></textarea>
    </template>

    <div v-if="loading" class="input__loading"></div>

    <div v-if="shouldShowValidationError()" class="input__validation-error-msg">
      {{ failureMsg }}
    </div>
    <div v-if="!shouldShowValidationError() && additionalInfo && additionalInfoShow" class="input__additional-info">
      <small>{{ additionalInfo }}</small>
    </div>

  </div>
</template>

<script>
  import inputLabelFullWidth from './inputLabelFullWidth'

  export default {
    name: 'inputWithValidation',
    props: [
      'label',
      'type',
      'regex',
      'failureMsg',
      'required',
      'maxLength',
      'halfWidth',
      'additionalInfo',
      'additionalInfoShow',
      'injectedValue',
      'loginOnEnter',
      'options',
      'val',
      'disabled'
    ],
    components: {
      inputLabelFullWidth
    },
    data () {
      return {
        pendingValue: this.value,
        valid: false,
        initialised: false,
        classes: '',
        showError: false,
        loading: false,
        value: this.injectedValue ? this.injectedValue : ''
      }
    },
    methods: {
      isValid () {
        if (this.isDisabled()) return true

        if (this.getValue() === '') {
          // If it's blank and required, it's not valid
          return !this.isRequired()
        }

        if (this.hasRegex()) {
          const regex = new RegExp(this.$props.regex, 'g')

          return regex.test(this.getValue())
        }

        return true
      },

      /**
       * Determines whether or not this input field is disabled
       * @return {Boolean}
       */
      isDisabled () {
        return this.disabled
      },

      /**
       * Determines whether or not this field is required
       * @return {Boolean}
       */
      isRequired () {
        return this.$props.required
      },

      /**
       * Determines whether or not this field has a regular expression
       * for checking validity
       * @return {Boolean}
       */
      hasRegex () {
        return this.$props.regex !== false
      },

      /**
       * Retrieves the value of this input field.
       * @return {String}
       */
      getValue () {
        return this.value
      },

      /**
       * Sets the value of this component, and then returns this for chainability
       * @param {String} value
       * @return {Self}
       */
      setValue (value) {
        this.value = value
        return this
      },

      /**
       * Disables this component so that the user can't modify the value, but
       * the value still gets submitted.
       * Returns self for chainability
       * @return {Self}
       */
      disableElm () {
        this.disabled = true
        return this
      },

      /**
       * Only disables the element if there's a value inside it
       * @return {Self}
       */
      disableElmIfVal () {
        if (this.getValue() !== '') this.disableElm()
        return this
      },

      /**
       * Re-enables this component so that the user can modify the value
       * Returns self for chainability
       * @return {Self}
       */
      reenableElm () {
        this.disabled = false
        return this
      },
      blur () {
        this.highlightError()
      },
      input (event) {
        this.$emit('input', event.target.value)
      },
      enter (e) {
        e.preventDefault()
        e.stopPropagation()
        if (this.$props.loginOnEnter) {
          this.$parent.attemptLogin()
          return false
        }
      },
      _getClassNames () {
        this.classes = ''
        if (this.isRequired()) this.classes += 'input--required '
        if (this.valid) this.classes += 'input--valid '
        if (this.initialised) this.classes += 'input--initialised '
      },

      /**
       * Mark the field as 'shouldShowError', so that if any errors come up,
       * they'll be show to the user.
       * @return {Void}
       */
      highlightError () {
        this.showError = true
      },

      /**
       * If the field is invalid and we're supposed to be showing the error,
       * then show the error.
       * @return {Boolean}
       */
      shouldShowValidationError () {
        return !this.isValid() && this.showError
      }

    },
    mounted () {
      if (!this.isRequired()) this.valid = true
    },
    watch: {
      value: function (value) {
        this.pendingValue = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// inputWithValidation.vue?fa373b50